<div [formGroup]="formGroup" [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.default">
	<!-- <div [formGroup]="formGroup" class="row flex-row margin-left-2"> -->
	<ng-container *ngFor="let formElement of formElements;">
		<hr *ngIf="formElement.lineAtStart">
		<ng-container *ngIf="!formElement.hide" [ngSwitch]="formElement.type">
			<!-- <ng-container *ngIf="!formElement.hide" class="form-group m-form__group" [ngSwitch]="formElement.type"> -->
			<input type="hidden" [formControlName]="formElement.name">
			<app-text [class]="elementClass" [disabled]="formElement.disabled" [(value)]="formElement.value"
				(change)="onChange($event)" (blur)="onBlur($event)" [ngClass]="formElement.alignClass"
				*ngSwitchCase="INPUT_TYPE.TEXT" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [message]="formElement.customValidationMessage"
						[control]="formGroup.controls[formElement.name]" [name]="formElement.validationName">
					</app-form-control-messages>
				</div>
			</app-text>
			<app-simple-text [class]="elementClass" [disabled]="formElement.disabled" [(value)]="formElement.value"
				(change)="onChange($event)" (blur)="onBlur($event)" [ngClass]="formElement.alignClass"
				*ngSwitchCase="INPUT_TYPE.SIMPLE_TEXT" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [message]="formElement.customValidationMessage"
						[control]="formGroup.controls[formElement.name]" [name]="formElement.validationName">
					</app-form-control-messages>
				</div>
			</app-simple-text>
			<app-text [class]="elementClass" [disabled]="formElement.disabled" (blur)="onBlur($event)"
				[(value)]="formElement.value" (change)="onChange($event)" type="textarea"
				[ngClass]="formElement.alignClass" *ngSwitchCase="INPUT_TYPE.TEXTAREA"
				[formValue]="formGroup.get(formElement.name)" [formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-text>
			<app-text [class]="elementClass" [disabled]="formElement.disabled" (blur)="onBlur($event)"
				[(value)]="formElement.value" (change)="onChange($event)" [ngClass]="formElement.alignClass"
				type="number" *ngSwitchCase="INPUT_TYPE.NUMBER" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-text>
			<app-text [class]="elementClass" [disabled]="formElement.disabled" (blur)="onBlur($event)"
				[(value)]="formElement.value" (change)="onChange($event)" [ngClass]="formElement.alignClass" type="date"
				*ngSwitchCase="INPUT_TYPE.DATE" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-text>
			<app-select [class]="elementClass" [disabled]="formElement.disabled" (blur)="onBlur($event)"
				[(value)]="formElement.value" (change)="onChange($event)" [ngClass]="formElement.alignClass"
				*ngSwitchCase="INPUT_TYPE.SELECT" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">

					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-select>
			<app-upload [class]="elementClass" [disabled]="formElement.disabled"
				[allowedFormats]="formElement.allowedFormats" (blur)="onBlur($event)"
				[isMultiSelect]="formElement.multi" [isReviewRequiredSelect]="formElement.isReviewRequired"
				[(value)]="formElement.value" (change)="onChange($event)" [ngClass]="formElement.alignClass" type="date"
				*ngSwitchCase="INPUT_TYPE.UPLOAD" [formValue]="formGroup.get(formElement.name)"
				[(localFile)]="formElement.temp.localFile" [(localFileValue)]="formElement.temp.localFileValue"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-upload>
			<app-checkbox [class]="elementClass" [disabled]="formElement.disabled" (blur)="onBlur($event)"
				[(value)]="formElement.value" (change)="onChange($event)" [ngClass]="formElement.alignClass"
				type="number" *ngSwitchCase="INPUT_TYPE.CHECKBOX" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-checkbox>
			<app-radio [class]="elementClass" [disabled]="formElement.disabled" [(value)]="formElement.value"
				(change)="onChange($event)" [ngClass]="formElement.alignClass" type="radio"
				*ngSwitchCase="INPUT_TYPE.RADIO" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-radio>
			<app-date-duration [class]="elementClass" [disabled]="formElement.disabled" (blur)="onBlur($event)"
				[(value)]="formElement.value" (change)="onChange($event)" [ngClass]="formElement.alignClass"
				[formValue]="formGroup.get(formElement.name)" [formElement]="formElement"
				*ngSwitchCase="INPUT_TYPE.DATE_DURATION">
				<div class="min-height">
					<app-form-control-messages [control]="formGroup.controls[formElement.name]"
						[name]="formElement.validationName"></app-form-control-messages>
				</div>
			</app-date-duration>

			<app-aadhar [class]="elementClass" [disabled]="formElement.disabled" [(value)]="formElement.value"
				(change)="onChange($event)" (blur)="onBlur($event)" [ngClass]="formElement.alignClass"
				*ngSwitchCase="INPUT_TYPE.AADHAR" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement">
				<div class="min-height">
					<app-form-control-messages [message]="formElement.customValidationMessage"
						[control]="formGroup.controls[formElement.name]" [name]="formElement.validationName">
					</app-form-control-messages>
				</div>
			</app-aadhar>

			<app-d-geo-location *ngSwitchCase="INPUT_TYPE.GEO_LOCATION" [class]="elementClass"
				[ngClass]="formElement.alignClass" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement" (change)="onChange($event)" (blur)="onBlur($event)">
				<div class="min-height">
					<app-form-control-messages [message]="formElement.customValidationMessage"
						[control]="formGroup.controls[formElement.name]" [name]="formElement.validationName">
					</app-form-control-messages>
				</div>
			</app-d-geo-location>
			<app-input-group *ngSwitchCase="INPUT_TYPE.INPUT_GROUP" [class]="elementClass"
				[ngClass]="formElement.alignClass" [formValue]="formGroup.get(formElement.name)"
				[formElement]="formElement" (change)="onChange($event)" (blur)="onBlur($event)">
				<div class="min-height">
					<app-form-control-messages [message]="formElement.customValidationMessage"
						[control]="formGroup.controls[formElement.name]" [name]="formElement.validationName">
					</app-form-control-messages>
				</div>
			</app-input-group>
		</ng-container>
		<hr *ngIf="formElement.lineAtEnd">
	</ng-container>
</div>